module.exports = __webpack_public_path__ + "img/onlineOrders.0ec22b71.svg";